import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2HreservationElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2HreservationElFindParams, unknown>

const fetchHReservationList = async (params: ApiV2HreservationElFindParams) => {
  const { data } = await apiClient.v2.apiV2HreservationElFind(params);
  return checkApiResponse(data);
}

export const v2HReservationKeys = {
  all: [QUERY_KEY.v2apiV2HreservationElFind] as const,
  list: (params: ApiV2HreservationElFindParams) => [...v2HReservationKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2HReservationFindQueryOptions(params))` */
export const v2HReservationFindQueryOptions = (params: ApiV2HreservationElFindParams) => ({
  queryKey: v2HReservationKeys.list(params),
  queryFn: () => fetchHReservationList(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useV2HReservationFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2HReservationKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHReservationList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
